import Routes from "./routes";
import { GlobalStyle } from "./styles";

import "./styles/fonts.css";

function App() {
  return (
    <>
      <GlobalStyle />
      <Routes />
    </>
  );
}

export default App;
